/**************************************************
 * Nombre:       Home_Servicios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {SERVICIOS} from "../../../Constantes";
import Tarjeta_Servicios from "../../Tarjetas/Tarjeta_Servicios";
import {theme} from "../../../Tema";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Home_Servicios = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', p: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{
                            backgroundColor: 'white',
                            boxShadow: 2,
                            py: !masSM ? 4 : 10,
                            px: !masSM ? 2 : 8
                        }}
                        spacing={0}

                    >


                        {SERVICIOS.map((item, index) => (
                            <Grid container size={{xs: 6, sm: 3, md: 3}}
                                  sx={{
                                      justifyContent: 'center',
                                    //  borderTop: index > 3 ? 1 : 0,
                                     // borderRight: index + 1 === 4 || index === 7 ? 0 : 1,
                                      borderColor: '#00000020',
                                      cursor: 'pointer',
                                      "&:hover": {
                                          backgroundColor: theme.palette.primary.main + 20
                                      }


                                  }}
                            >
                                <Tarjeta_Servicios item={item} index={index}/>
                            </Grid>
                        ))}


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Servicios

